import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { ProvincesListWrapper } from './provinces-list/ProvincesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const provincesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Province Management',
    path: '/admin/pages/provinces',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/provinces/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const ProvincesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='provinces'
          index
          element={
            <>
              <PageTitle breadcrumbs={provincesBreadcrumbs}>Provinces list</PageTitle>
              <ProvincesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/provinces/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/provinces' />} />
    </Routes>
  )
}

export default ProvincesPage
